<template>
  <div class="newlist">
    <ul class="list" v-if="list.length>0">
      <li class="animation" v-for="item in list" :key="item.id">
        <router-link
          :to="{name:'party',params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:item.id}}"
          class="clearfix"
          title
        >
          <div class="time">
            <p>{{item.addDate|formatDate}}</p>
            <span>{{item.addDate|formatDate("year")}}</span>
          </div>
          <div class="txt">
            <h3>{{item.listTitle}}</h3>
            <span>{{item.addDate.split(" ")[0]}}</span>
            <p></p>
          </div>
          <span class="more">了解详情</span>
        </router-link>
      </li>
    </ul>
    <div class="admin-page">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5,10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getNewsList } from "@/api/index";
export default {
  props: {
    id: [Number, String]
  },
  data() {
    return {
      currentPage: 0,
      pageSize: 5,
      contentData: null,
      totalCount: 0,
      list: []
    };
  },
  created() {
    this.getNewsListFun({
      pageNo: this.currentPage,
      pageSize: this.pageSize,
      condition: {
        nodeId: this.$props.id
      }
    });
  },
  methods: {
    // 获取二级列表内容
    getNewsListFun(json) {
      getNewsList(json).then(res => {
        if (res.data.code == 1000) {
          this.$set(this.$data, "list", res.data.data.data);
          this.$set(this.$data, "totalCount", res.data.data.totalCount);
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNewsListFun({
        pageNo: this.currentPage,
        pageSize: val,
        condition: {
          nodeId: this.$props.id
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNewsListFun({
        pageNo: val - 1,
        pageSize: this.pageSize,
        condition: {
          nodeId: this.$props.id
        }
      });
    }
  }
};
</script>